import { CustomFieldDefinitionTypes } from 'common/store/common/constants';
import { ActionTypes, TypeKeys } from './actions';
import { CustomFieldsDefinitionBase, CustomFieldsDefinitionKit } from './types';

export interface CustomFieldsDefinitionState extends CustomFieldsDefinitionBase {
    customFieldsDefinitionKit?: Array<CustomFieldsDefinitionKit>;
    isDataLoading?: boolean;
    isReviewFields?: boolean;
}

export const initialState: CustomFieldsDefinitionState = {
    [CustomFieldDefinitionTypes.SECTION]: [],
    [CustomFieldDefinitionTypes.QUESTION_SET]: [],
    [CustomFieldDefinitionTypes.QUESTION]: [],
    [CustomFieldDefinitionTypes.CONTENT_SOUND]: [],
    customFieldsDefinitionKit: [],
    isDataLoading: false,
    isReviewFields: false,
};

export const customFieldsDefinitionReducer = (
    state: CustomFieldsDefinitionState = initialState,
    action: ActionTypes
): CustomFieldsDefinitionState => {
    switch (action.type) {
    case TypeKeys.CB_CUSTOM_FIELD_DEFINITIONS_LOADED:
        return {
            ...state,
            [CustomFieldDefinitionTypes.SECTION]: action.payload,
        };
    case TypeKeys.QUESTION_CUSTOM_FIELD_DEFINITIONS_LOADED:
        return {
            ...state,
            [CustomFieldDefinitionTypes.QUESTION]: action.payload,
        };
    case TypeKeys.QUESTION_SET_CUSTOM_FIELD_DEFINITIONS_LOADED:
        return {
            ...state,
            [CustomFieldDefinitionTypes.QUESTION_SET]: action.payload,
        };
    case TypeKeys.CONTENT_SOUND_CUSTOM_FIELD_DEFINITIONS_LOADED:
        return {
            ...state,
            [CustomFieldDefinitionTypes.CONTENT_SOUND]: action.payload,
        };
    case TypeKeys.CUSTOM_FIELDS_DEFINITION_KIT_CHANGED:
        return {
            ...state,
            customFieldsDefinitionKit: action.payload,
        };
    case TypeKeys.CUSTOM_METADATA_FIELDS_LOADER_CHANGED:
        return {
            ...state,
            isDataLoading: action.payload,
        };
    case TypeKeys.SET_IS_REVIEW_FIELDS:
        return {
            ...state,
            isReviewFields: action.payload,
        };
    default:
        return state;
    }
};
